/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da div 
 */
export default styled.div`
  height: 100%;

  button {
    height: 42px;
    background: transparent;
    box-sizing: border-box;
    border: none;
    padding-top: 4px;
    color: #fff;
    text-transform: uppercase;

    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    outline: none;

    svg {
      path {
        fill: ${({ theme }) => theme.icons};
      }
    }

    * {
      margin: 0;
      padding: 0;
    }

    &.desktop {
      border-bottom: ${({ active, theme }) =>
        active
          ? `4px solid ${theme.primaryColor}`
          : `4px solid ${theme.primaryColorDark}`};
      min-width: 100px;
    }

    &.mobile {
      min-width: 55px;
    }
  }
`;
